import { render, staticRenderFns } from "./AppCounter.vue?vue&type=template&id=1de698b3"
import script from "./AppCounter.vue?vue&type=script&lang=js"
export * from "./AppCounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports